<template>
    <div class="diagnostics">
        <div class="diagnostics-header">
            <div class="header_name-container">
                <div class="name-icon">
                    <img :src="getPhotoUrl(getIndicators.info)" alt="" class="add-files_form_img_cropp">
                </div>
                <div class="name">
                    <p>ФИО</p>
                    <input v-model="getIndicators.info.fio" readonly type="text" name="patientName" id="patientName" placeholder="Введите текст">
                </div>
                <div class="name gender">
                    <p>Пол</p>
                    <input :value="getIndicators.info.gender === 0 ? 'Мужской' : 'Женский'" readonly type="text" name="patientName" id="patientName" placeholder="Введите текст">
                </div>
                <div class="name gender">
                    <p>Дата рождения</p>
                    <input :value="getIndicators.info.birthday | filterBirthday" readonly />
                </div>
                <div class="name">
                    <p>Возраст</p>
                    <input :value="getIndicators.info.episodeAge" readonly />
                </div>
            </div>
        </div>

        <div class="body-container">
            <div class="left-container">
                <div class="left-container-main" v-for="(el, ind) in getDiagnostic.levels" :key="ind">
                    <div class="left-container-main-general">
                        <div class="left-container-main-general__left" @click="el.loading ? '' : nextStep(el, ind)">
                            <svg v-if="ind != 0" xmlns="http://www.w3.org/2000/svg" width="2" height="12" viewBox="0 0 2 12" fill="none">
                                <path d="M1.5 1C1.5 0.723858 1.27614 0.5 1 0.5C0.723858 0.5 0.5 0.723858 0.5 1H1.5ZM0.5 1V2.375H1.5V1H0.5ZM0.5 5.125V7.875H1.5V5.125H0.5ZM0.5 10.625V12H1.5V10.625H0.5Z" fill="#AAAEB7"/>
                            </svg>
                            <div
                                class="left-item"
                                :class="{
                                    'activeNum': getDiagnostic.currentStep == ind,
                                    'passed': getDiagnostic.levels[ind].visibleType === 2,
                                    'skip': getDiagnostic.levels[ind].visibleType === 3
                                }"
                            >
                                <div class="item-num">{{ind+1}}</div>
                                <p>{{ el.sectionName }}</p>

                                <v-overlay :value="el.loading" absolute opacity="0.36" color="#b8b8b8">
                                    <v-progress-circular indeterminate size="24" />
                                </v-overlay>
                            </div>
                        </div>
                        <div
                            v-if="el.visibleType === 2 && !getFlagReadonly"
                            class="left-container-main-general__right"
                            :class="{
                                'mt-2': ind == 0,
                                'mt-8': ind != 0,
                            }"
                        >
                            <inline-svg
                                title="Пропустить раздел"
                                class="cursor-pointer"
                                :src="require(`@/assets/img/icons/EyeOff.svg`)"
                                @click.prevent="skipFunction(ind)"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-container">
                <Complaints v-if="getDiagnostic.currentStep == 0 && !getDiagnostic.levels[0].loading"/>
                <Anamnesis v-if="getDiagnostic.currentStep == 1 && !getDiagnostic.levels[0].loading"/>
                <Inspection v-if="getDiagnostic.currentStep == 2 && !getDiagnostic.levels[0].loading"/>
                <Palpation v-if="getDiagnostic.currentStep == 3 && !getDiagnostic.levels[0].loading"/>
                <Perkusion v-if="getDiagnostic.currentStep == 4 && !getDiagnostic.levels[0].loading"/>
                <Auscultation v-if="getDiagnostic.currentStep == 5 && !getDiagnostic.levels[0].loading"/>
                <Syndromic v-if="getDiagnostic.currentStep == 6 && !getDiagnostic.levels[0].loading"/>
                <Preliminary v-if="getDiagnostic.currentStep == 7 && !getDiagnostic.levels[0].loading"/>
                <Laboratory v-if="getDiagnostic.currentStep == 8 && !getDiagnostic.levels[0].loading"/>
                <Instrumental v-if="getDiagnostic.currentStep == 9 && !getDiagnostic.levels[0].loading"/>
                <Final v-if="getDiagnostic.currentStep == 10 && !getDiagnostic.levels[0].loading" />
            </div>
        </div>

        <div class="containerShadow" v-if="getDiagnostic.dialog">
            <div class="containerEl">
                <div class="addSkip">
                    <h1>Внимание</h1>
                    <p>Добавить шаг "{{ getDiagnostic.levels[getSelectedIndex].sectionName }}" или Пропустить?</p>
                    <div class="addSkip-btn">
                        <button class="custom-button" type="button" @click.prevent="skipStepDiagnostic">Пропустить</button>
                        <button class="custom-button" type="button" @click.prevent="nextStepDiagnostic">Добавить</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="containerShadow" v-if="dialogSkip">
            <div class="containerEl">
                <div class="addSkip">
                    <h1>Внимание</h1>
                    <p>Вы уверены, что хотите убрать шаг "{{ getDiagnostic.levels[getSelectedIndex].sectionName }}"?</p>
                    <div class="addSkip-btn">
                        <button class="custom-button" type="button" @click.prevent="dialogSkip = false">Закрыть окно</button>
                        <button class="custom-button" type="button" @click.prevent="cancelStep">Пропустить этот шаг</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="containerShadow" v-if="getDiagnostic.dialogMedia">
            <div class="containerEl">
                <button class="close" @click.prevent="changeFlagMedia(false)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="addMedia">
                    <h2>Медиафайлы</h2>
                    <div class="createTest-tabs">
                        <v-tabs v-model="tabMedia" align-with-title>
                            <v-tab v-for="(item, key) in itemsMedia" :key="item" >
                                {{ item }}
                                <span v-if="key === 0">({{ getDiagnostic.selectedCircle.files.filter((f) => f.fileType === 3).length }})</span>
                                <span v-if="key === 1">({{ getDiagnostic.selectedCircle.files.filter((f) => f.fileType === 4).length }})</span>
                                <span v-if="key === 2">({{ getDiagnostic.selectedCircle.files.filter((f) => f.fileType === 2).length }})</span>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tabMedia">
                            <v-tab-item v-for="item in itemsMedia" :key="item" >
                                <v-btn
                                    v-if="!getFlagReadonly"
                                    @click="getFilesForIPPA(item, false)"
                                    :loading="loadTable"
                                    color="outline-primary"
                                    class="btn-load__edite mt-3"
                                    height="46"
                                    type="button"
                                >
                                    + Добавить
                                </v-btn>

                                <div class="media-container" v-if="item == 'Аудиофайлы'">
                                    <media-files
                                        v-if="getDiagnostic.selectedCircle.files.length > 0"
                                        :files="getDiagnostic.selectedCircle.files.filter((f) => f.fileType === 3)"
                                        :flagDiag="true"
                                        :flagNameAndBtn="true"
                                        :flagButtonDel="true"
                                        :fileType="3"
                                    />
                                </div>

                                <div class="media-container" v-if="item == 'Видеофайлы'">
                                    <media-files
                                        v-if="getDiagnostic.selectedCircle.files.length > 0"
                                        :files="getDiagnostic.selectedCircle.files.filter((f) => f.fileType === 4)"
                                        :flagDiag="true"
                                        :flagNameAndBtn="true"
                                        :flagButtonDel="true"
                                        :fileType="4"
                                    />
                                </div>

                                <div class="media-container" v-if="item == 'Изображение'">
                                    <media-files
                                        v-if="getDiagnostic.selectedCircle.files.length > 0"
                                        :files="getDiagnostic.selectedCircle.files.filter((f) => f.fileType === 2)"
                                        :flagDiag="true"
                                        :flagDiagImage="true"
                                        :flagButtonDel="true"
                                        :flagNameAndBtn="true"
                                        :fileType="2"
                                    />
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                </div>
            </div>
        </div>

        <div class="containerShadow" v-if="getDiagnostic.flagInstrumental">
            <div class="containerEl">
                <button :disabled="loadTable" class="close" @click.prevent="changeFlagConstructor({ name: 'flagInstrumental', value: false })">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="addMedia">
                    <h2>Медиафайлы</h2>
                    <div class="createTest-tabs">
                        <v-btn
                            v-if="!getFlagReadonly"
                            @click="getFilesForIPPA('Фото', true)"
                            :loading="loadTable"
                            color="outline-primary"
                            class="btn-load__edite mt-3"
                            height="46"
                            type="button"
                        >
                            + Добавить
                        </v-btn>

                        <div class="media-container">
                            <media-files
                                v-if="getDiagnostic.selectedInstrumentalFile.length > 0"
                                :files="getDiagnostic.selectedInstrumentalFile"
                                :flagDiag="true"
                                :flagButtonDel="true"
                                :flagDiagImage="true"
                                :flagNameAndBtn="true"
                                :fileType="2"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="getDiagnostic.dialogAddMedia" persistent max-width="1000">
            <div class="add-files">
                <div class="add-files-label">
                    <div class="add-files_header">
                        <h2>Добавить файл</h2>
                        <button class="filter-btn" @click="close()">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" >
                                <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round" />
                                <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </button>
                    </div>
                    <div class="media-files_headline add-files-dialog">
                        <div class="media-files_left">
                            <div class="media-files_search">
                                <label for="file">Поиск</label>
                                <input id="file" v-model="search" class="media-files_search-input" />
                            </div>
                            <div class="media-files_switch">
                                <label for="switch">Мои файлы</label>
                                <v-switch
                                    v-model="getDiagnostic.filterMedia.author"
                                    @change="mediaFilter(getDiagnostic.filterMedia)"
                                    color="primary"
                                    id="switch"
                                    :value="userName"
                                    label=""
                                    hide-details
                                />
                            </div>
                            <div class="media-files_select">
                                <label for="type">Тип файла</label>
                                <v-select
                                    id="type"
                                    v-model="getDiagnostic.filterMedia.fileType"
                                    :items="mediaType"
                                    class="media-files_search-select"
                                    hide-details
                                    :disabled="getDiagnostic.filterMedia.disabled"
                                    @change="mediaFilter(getDiagnostic.filterMedia)"
                                    outlined
                                ></v-select>
                            </div>
                        </div>
                    </div>
                    <div class="table">
                        <v-data-table
                            v-model="selected"
                            single-select
                            show-select
                            :headers="headers"
                            :items="mediaData"
                            :loading="loadTable"
                            ref="table"
                            @pagination="paginations($event)"
                            :page="page"
                            hide-default-footer
                            :items-per-page="itemsPerPage"
                            :search="search"
                        >
                            <template v-slot:[`item.mediaFileTags`]="{ item }">
                                <span>{{
                                item.mediaFileTags
                                    .map((item) => {
                                    return item.mediaFileTag.tagName;
                                    })
                                    .join(", ")
                                }}</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        small
                                        @click="viewFile(item)"
                                        class="mr-2"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        mdi-eye
                                    </v-icon>
                                    </template>
                                    <span>Просмотр</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:footer="{ props }">
                                <div class="data-footer">
                                    <div class="items-per-page">
                                        <span>Строк на странице:</span>
                                        <div class="items-per-page_item" :class="{ active: itemsPerPage == 5 }" @click.prevent="itemsPerPage = 5">5</div>
                                        <div class="items-per-page_item" :class="{ active: itemsPerPage == 10 }" @click.prevent="itemsPerPage = 10">10</div>
                                        <div class="items-per-page_item" :class="{ active: itemsPerPage == 15 }" @click.prevent="itemsPerPage = 15">15</div>
                                        <div class="items-per-page_item" :class="{ active: itemsPerPage == -1 }" @click.prevent="itemsPerPage = -1">все</div>
                                    </div>
                                    <div class="pagination" v-if="itemsPerPage != -1">
                                        <div class="pagination_prev" @click.prevent="page == 1 ? page : --page" >
                                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z"
                                                    fill="#94969C"
                                                />
                                            </svg>
                                        </div>
                                        <div class="pagination_number">
                                            {{ itemsPerPage * (page - 1) + 1 }} -
                                            {{ itemsPerPage * (page - 1) + itemsPerPage }} из
                                            {{ props.pagination.itemsLength }}
                                        </div>
                                        <div
                                            class="pagination_next"
                                            v-if="itemsPerPage"
                                            @click.prevent="page == parseInt(props.pagination.itemsLength / itemsPerPage, 10) ? page : ++page"
                                        >
                                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z"
                                                    fill="#94969C"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </v-data-table>

                        <MediaViewDialog ref="mediaViewDialog" />

                        <v-btn v-if="getDiagnostic.flagInstrumental" @click="addFilesInstrumental(selected)" :loading="loadingSaveInstrumental" color="primary" class="btn-load__edite mt-3 mb-1" block height="46" type="button">
                            Добавить
                        </v-btn>

                        <v-btn v-else @click="addFiles(selected)" :loading="loadingSaveFileToBodyPart" color="primary" class="btn-load__edite mt-3 mb-1" block height="46" type="button">
                            Добавить
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-dialog>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import inlineSvg from 'vue-inline-svg'
import Complaints from './Complaints/index.vue'
import Anamnesis from './Anamnesis/index.vue'
import Inspection from './Inspection/index.vue'
import Palpation from './Palpation/index.vue'
import Auscultation from './Auscultation/index.vue'
import Perkusion from './Perkusion/index.vue'
import Syndromic from './Syndromic/index.vue'
import Preliminary from './Preliminary/index.vue'
import Laboratory from './Laboratory/index.vue'
import Instrumental from './Instrumental/index.vue'
import Final from './Final/index.vue'
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import mediaFiles from '@/components/TaskMediaFiles.vue';
import MediaViewDialog from '@/components/MediaFiles/ViewDIalog.vue';

export default {
    name: 'Diagnostics',
    components: {
        Complaints,
        Anamnesis,
        Inspection,
        Palpation,
        Auscultation,
        Perkusion,
        Syndromic,
        Preliminary,
        Laboratory,
        Instrumental,
        Final,
        TimeoutSnackbar,
        mediaFiles,
        MediaViewDialog,
        inlineSvg
    },
    computed: {
        ...mapGetters({
            apiImg: 'apiImg',
            getIndicators: 'createDiagnosticTest/getIndicators',
            getDiagnostic: 'createDiagnosticTest/getDiagnostic',
            getSelectedIndex: 'createDiagnosticTest/getSelectedIndex',
            mediaType: "media/mediaType",
            mediaData: "media/mediaData",
            userName: "login/userName",
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        })
    },
    data: () => ({
        dialogSkip: false,
        headers: [
            { text: "Описание", value: "description" },
            { text: "Тeги", value: "mediaFileTags" },
            { text: "Файл", value: "fileName" },
            { text: "", value: "actions", sortable: false, align: "right" },
        ],
        loadingSaveFileToBodyPart: false,
        loadingSaveInstrumental: false,
        loadTable: false,
        search: '',
        page: 1,
        itemsPerPage: 5,
        selected: [],
        paginations(event) {
            this.page = event.page;
            this.itemsPerPage = event.itemsPerPage;
        },
        lists: [
            'Отсутствует',
            'Генеральные отеки',
            'Переферические отеки'
        ],
        tabMedia: null,
        itemsMedia: [ 'Аудиофайлы', 'Видеофайлы', 'Изображение' ],
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        }
    }),
    methods: {
        ...mapActions({
            saveFlagsForDiagnostic: 'createDiagnosticTest/saveFlagsForDiagnostic',
            getVisibleBlockInDiagnostic: 'createDiagnosticTest/getVisibleBlockInDiagnostic',
            getFiles: 'media/getFiles',
            savingFile: 'createDiagnosticTest/savingFile'
        }),
        ...mapMutations({
            checkNextStep: 'createDiagnosticTest/checkNextStep',
            changeFlagMissingStep: 'createDiagnosticTest/changeFlagMissingStep',
            nextSection: 'createDiagnosticTest/nextSection',
            changeFlagMedia: 'createDiagnosticTest/changeFlagMedia',
            changeFlagAddMedia: 'createDiagnosticTest/changeFlagAddMedia',
            mediaFilter: "media/mediaFilter",
            changeSelectedIndex: "createDiagnosticTest/changeSelectedIndex",
            changeFilterMedia: "createDiagnosticTest/changeFilterMedia",
            changeFlagConstructor: 'createDiagnosticTest/changeFlagConstructor',
        }),
        nextStep(tabElenemt, index) {
            // Если это просмотр и пункт пропущен в создании/редактировании теста, то предупреждение выбрасываем
            if(this.getFlagReadonly && tabElenemt.visibleType !== 2) {
                this.snackbar = { text: `Шаг "${tabElenemt.sectionName}" ${tabElenemt.visibleType == 1 ? 'не был выбран' : 'был пропущен' }, просмотр невозможен!`, color: 'info', timeout: 3000, show: true };

                return;
            }

            // если текущая нумерация и так выбрана, выходим из функции
            if(this.getDiagnostic.currentStep === index) {
                return;
            }

            if(tabElenemt.visibleType === 2) {
                this.nextSection(index);
            } else {
                this.changeFlagMissingStep({ flag: true, index: index });
            }
        },
        skipFunction(index) {
            this.changeSelectedIndex(index);
            this.nextSection(0);
            this.dialogSkip = true;
        },
        saveFlags(index) {
            this.saveFlagsForDiagnostic({
                id: this.getDiagnostic.levels[index].id,
                diaTestId: this.$route.params.id,
                sectionId: this.getDiagnostic.levels[index].sectionId,
                visibleType: this.getDiagnostic.levels[index].visibleType,
                sectionName: this.getDiagnostic.levels[index].sectionName,
                sectionOrd: this.getDiagnostic.levels[index].sectionOrd
            });
        },
        skipStepDiagnostic() {
            this.checkNextStep({ methods: 'skip', nextIndex: this.getSelectedIndex });
            this.saveFlags(this.getSelectedIndex);
        },
        nextStepDiagnostic() {
            this.checkNextStep({ methods: 'add', nextIndex: this.getSelectedIndex });
            this.saveFlags(this.getSelectedIndex);
        },
        getPhotoUrl(obj) {
            if (obj.logoUrl) {
                return `${this.apiImg}${obj.logoUrl}`;
            }

            if (obj.gender === 1) {
                return require('@/assets/img/avatar-boy.png');
            }

            if (obj.gender === 2) {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        },
        viewFile(item) {
            this.$refs.mediaViewDialog.open(item);
        },
        addFilesInstrumental(file) {
            if(!file || file.length === 0) {
                return;
            }

            this.loadingSaveInstrumental = true;

            this.savingFile( {params: {
                diaTestId: this.$route.params.id,
                propertyId: this.getDiagnostic.selectPropertyInstrumental.propertyId,
                fileId: file[0].id,
                fileName: file[0].fileName,
                fileDescription: file[0].description,
                sectionId: '00000000-0000-0000-0000-000000000010',
                filePath: file[0].filePath,
                fileType: file[0].fileType
            }, nameProperty: 'selectedInstrumentalFile'})
            .then(() => {
                this.loadingSaveInstrumental = false;
                this.changeFlagAddMedia(false);
            })
        },
        addFiles(files) {
            let currentStep = this.getDiagnostic.currentStep, actionType;
            if(currentStep === 2) actionType = 1;
            if(currentStep === 3) actionType = 2;
            if(currentStep === 4) actionType = 3;
            if(currentStep === 5) actionType = 4;

            this.loadingSaveFileToBodyPart = true;

            this.savingFile({ params: {
                diaTestId: this.$route.params.id,
                actionType: actionType,
                bodyPartId: this.getDiagnostic.selectedCircle.bodyPartId,
                propertyId: this.getDiagnostic.selectedProperty.propertyId,
                bodySystemId: this.getDiagnostic.selectedProperty.bodySystemId,
                bodySystemName: this.getDiagnostic.selectedProperty.bodySystemName,
                fileId: files[0].id,
                bodyPartName: this.getDiagnostic.selectedCircle.name,
                fileName: files[0].fileName,
                fileDescription: files[0].description,
                filePath: files[0].filePath,
                fileType: files[0].fileType,
            }, nameProperty: 'selectedCircle', nameProperty2: 'files'})
            .then(() => {
                this.loadingSaveFileToBodyPart = false;
                this.close();
            })
        },
        close() {
            this.selected = [];
            this.search = "";
            this.changeFilterMedia({ author: '', fileType: '', disabled: false });
            this.changeFlagAddMedia(false);
        },
        getFilesForIPPA(name, disabled) {
            console.log(this.getDiagnostic.selectedInstrumentalFile.length , this.getDiagnostic.flagInstrumental);
            if (this.getDiagnostic.selectedInstrumentalFile.length === 0 && this.getDiagnostic.flagInstrumental) {
                this.selected = [];
            }
            this.changeFilterMedia({
                author: '',
                fileType: name === 'Аудиофайлы' ? 'Аудио' : ( name === 'Видеофайлы' ? 'Видео' : 'Фото' ),
                disabled: disabled
            })

            if(this.mediaData.length > 0) {
                this.changeFlagAddMedia(true);
                this.mediaFilter(this.getDiagnostic.filterMedia);
                return;
            }

            this.loadTable = true;
            this.getFiles()
                .then(() => {
                    this.loadTable = false;
                    this.changeFlagAddMedia(true);
                    this.mediaFilter(this.getDiagnostic.filterMedia);
                })
        },
        cancelStep() {
            this.skipStepDiagnostic();
            this.dialogSkip = false;
        }
    },
    created() {
        this.getVisibleBlockInDiagnostic(this.$route.params.id);
    }
}
</script>
